import Hero from "../../components/sections/Hero"
import ImageCarousel from "../../components/sections/Plans/Carroussel";
import WhatsappButton from "../../components/sections/Services/WhatsappButton";
function Home() {
  return (
    <div className="">
      <section id="inicio">
        <Hero />
      </section>
      <section className="container py-24">
        <ImageCarousel />
                  <WhatsappButton/>
      </section>
    </div>
  );
}
export default Home;